import { render, staticRenderFns } from "./changeEmail.vue?vue&type=template&id=53e0b4ca"
import script from "./changeEmail.vue?vue&type=script&lang=ts"
export * from "./changeEmail.vue?vue&type=script&lang=ts"
import style0 from "./changeEmail.vue?vue&type=style&index=0&id=53e0b4ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports